__turbopack_context__.v({
  "footer": "Footer-module-scss-module__enR8DW__footer",
});
